/* ════════════════════════════════════════
   SPLASHAUS — main.js
════════════════════════════════════════ */

// ── CUSTOM CURSOR ──────────────────────
const cursor = document.querySelector('.cursor');
if (cursor && !('ontouchstart' in window)) {
  document.addEventListener('mousemove', e => {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top  = e.clientY + 'px';
    cursor.classList.add('active');
  });
  document.querySelectorAll('a, button, .gallery-item, .ticket-card').forEach(el => {
    el.addEventListener('mouseenter', () => cursor.classList.add('big'));
    el.addEventListener('mouseleave', () => cursor.classList.remove('big'));
  });
}

// ── NAV SCROLL STATE ───────────────────
const nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
}

// ── NACHLADEN (Deko, Ticket-Fotos) ─────
// Bilder mit data-lazy-src laden erst kurz bevor sie in den Viewport kommen,
// damit sie beim Seitenstart nicht mit Headline, Font und Poster um Bandbreite konkurrieren.
(function initLazySrc() {
  const imgs = document.querySelectorAll('img[data-lazy-src]');
  const load = img => {
    img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
    img.src = img.dataset.lazySrc;
    img.removeAttribute('data-lazy-src');
  };
  if (!('IntersectionObserver' in window)) { imgs.forEach(load); return; }
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      // Im Karussell alle Bilder auf einmal laden (horizontal verdeckte Karten schneiden den Viewport nie)
      const track = e.target.closest('.carousel__track');
      const group = track ? track.querySelectorAll('img[data-lazy-src]') : [e.target];
      group.forEach(img => { load(img); io.unobserve(img); });
    });
  }, { rootMargin: '600px 0px' });
  const start = () => imgs.forEach(img => io.observe(img));
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();

// ── MOBILE DRAWER ──────────────────────
const drawer   = document.getElementById('navDrawer');
const backdrop = document.getElementById('navBackdrop');
const burger   = document.getElementById('navBurger');
const closeBtn = document.getElementById('navClose');

function openDrawer() {
  // Drawer-Fotos erst beim ersten Öffnen laden (sonst ziehen sie beim Seitenstart Bandbreite)
  drawer.querySelectorAll('img[data-src]').forEach(img => { img.src = img.dataset.src; img.removeAttribute('data-src'); });
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  backdrop.classList.add('visible');
  burger.classList.add('open');
  burger.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
}

function closeDrawer() {
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  backdrop.classList.remove('visible');
  burger.classList.remove('open');
  burger.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
}

burger?.addEventListener('click', () => {
  drawer.classList.contains('open') ? closeDrawer() : openDrawer();
});
closeBtn?.addEventListener('click', closeDrawer);
backdrop?.addEventListener('click', closeDrawer);
drawer?.querySelectorAll('a').forEach(a => a.addEventListener('click', closeDrawer));

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') closeDrawer();
});

// ── FAQ ACCORDION ──────────────────────
function openFaqItem(item) {
  document.querySelectorAll('.faq-item.open').forEach(open => {
    open.classList.remove('open');
    open.querySelector('.faq-answer').style.maxHeight = '0';
    open.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
  });
  const answer = item.querySelector('.faq-answer');
  const btn    = item.querySelector('.faq-question');
  item.classList.add('open');
  answer.style.maxHeight = answer.scrollHeight + 'px';
  btn.setAttribute('aria-expanded', 'true');
}

document.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', () => {
    const item   = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    if (isOpen) {
      item.classList.remove('open');
      item.querySelector('.faq-answer').style.maxHeight = '0';
      btn.setAttribute('aria-expanded', 'false');
    } else {
      openFaqItem(item);
    }
  });
});

// Auto-open FAQ item when URL hash matches its id
if (window.location.hash) {
  var target = document.querySelector(window.location.hash + '.faq-item');
  if (target) {
    setTimeout(function() {
      openFaqItem(target);
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);
  }
}

// ── TICKET CAROUSEL ────────────────────
(function initCarousel() {
  const viewport = document.querySelector('.carousel__viewport');
  const track    = document.getElementById('carouselTrack');
  const prevBtn  = document.getElementById('carouselPrev');
  const nextBtn  = document.getElementById('carouselNext');
  const dotsWrap = document.getElementById('carouselDots');

  if (!track) return;

  const cards = Array.from(track.querySelectorAll('.ticket-card'));
  let idx = 0;

  function visible() {
    const w = window.innerWidth;
    if (w >= 1025) return 4;
    if (w >= 769)  return 2;
    return 1;
  }

  function maxIdx() { return Math.max(0, cards.length - visible()); }

  function offset() {
    const card = cards[0];
    const gap  = parseInt(getComputedStyle(track).gap) || 20;
    return idx * (card.offsetWidth + gap);
  }

  function go(n) {
    idx = Math.max(0, Math.min(n, maxIdx()));
    track.style.transform = `translateX(-${offset()}px)`;
    renderDots();
  }

  function renderDots() {
    if (!dotsWrap) return;
    const total = maxIdx() + 1;
    dotsWrap.innerHTML = '';
    for (let i = 0; i < total; i++) {
      const d = document.createElement('button');
      d.className = 'carousel__dot' + (i === idx ? ' active' : '');
      d.setAttribute('aria-label', `Ticket ${i + 1}`);
      d.addEventListener('click', () => go(i));
      dotsWrap.appendChild(d);
    }
    if (prevBtn) prevBtn.disabled = idx === 0;
    if (nextBtn) nextBtn.disabled = idx >= maxIdx();
  }

  prevBtn?.addEventListener('click', () => go(idx - 1));
  nextBtn?.addEventListener('click', () => go(idx + 1));

  let tx = 0;
  viewport?.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
  viewport?.addEventListener('touchend', e => {
    const diff = tx - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) go(idx + (diff > 0 ? 1 : -1));
  });

  window.addEventListener('resize', () => go(Math.min(idx, maxIdx())));
  go(0);
})();

// ── SCROLL REVEAL ──────────────────────
if (window.innerWidth > 768) {
  const revealObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach((el, i) => {
    const siblings = Array.from(el.parentElement.querySelectorAll(':scope > .reveal'));
    const pos = siblings.indexOf(el);
    if (pos > 0) el.style.transitionDelay = (pos * 0.08) + 's';
    revealObs.observe(el);
  });
}

// ── CARD 3D TILT ───────────────────────
if (window.innerWidth > 768) {
  document.querySelectorAll('.tilt-card').forEach(card => {
    card.addEventListener('mousemove', e => {
      const rect = card.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width  - 0.5;
      const y = (e.clientY - rect.top)  / rect.height - 0.5;
      card.style.transform = `perspective(800px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg) translateY(-4px)`;
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });
}

// ── SMOOTH ANCHOR SCROLL ───────────────
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    const navEl = document.getElementById('nav');
    const top = target.getBoundingClientRect().top + window.scrollY - (navEl ? navEl.offsetHeight : 0) - 20;
    window.scrollTo({ top, behavior: 'smooth' });
  });
});

// ── ARTWORK CAROUSEL ──────────────────
(function initArtworkCarousel() {
  const outer   = document.getElementById('artworksOuter');
  const track   = document.getElementById('artworksTrack');
  const prevBtn = document.getElementById('artworksPrev');
  const nextBtn = document.getElementById('artworksNext');
  if (!track) return;

  const cards = Array.from(track.querySelectorAll('.artwork-card'));
  let idx = 0;

  function go(n, instant) {
    idx = Math.max(0, Math.min(n, cards.length - 1));
    const outerW = outer.clientWidth;
    const cardW  = cards[0].offsetWidth;
    const gap    = parseFloat(getComputedStyle(track).gap) || 32;
    const center = outerW / 2 - cardW / 2;
    const offset = idx * (cardW + gap) - center;
    if (instant) track.style.transition = 'none';
    track.style.transform = `translateX(${-offset}px)`;
    if (instant) { track.getBoundingClientRect(); track.style.transition = ''; }
    cards.forEach((c, i) => c.classList.toggle('aw-active', i === idx));
    if (prevBtn) prevBtn.disabled = idx === 0;
    if (nextBtn) nextBtn.disabled = idx >= cards.length - 1;
  }

  prevBtn?.addEventListener('click', () => go(idx - 1));
  nextBtn?.addEventListener('click', () => go(idx + 1));

  let tx = 0;
  outer?.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
  outer?.addEventListener('touchend', e => {
    const diff = tx - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 45) go(idx + (diff > 0 ? 1 : -1));
  });

  let dragging = false, dragX = 0, dragIdx = 0;
  outer?.addEventListener('mousedown', e => { dragging = true; dragX = e.clientX; dragIdx = idx; outer.style.cursor = 'grabbing'; });
  document.addEventListener('mouseup', e => {
    if (!dragging) return;
    dragging = false;
    outer.style.cursor = '';
    const diff = dragX - e.clientX;
    if (Math.abs(diff) > 45) go(dragIdx + (diff > 0 ? 1 : -1));
  });

  window.addEventListener('resize', () => go(idx, true));
  go(0, true);
})();

// ── USP SCROLL REVEAL ─────────────────
const uspObs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('in-view');
      uspObs.unobserve(e.target);
    }
  });
}, { threshold: 0.12 });

document.querySelectorAll('.usp').forEach(el => uspObs.observe(el));


// ── PROOF BAND ────────────────────────
(function initProofBand() {
  const band = document.querySelector('.proof-band');
  const bar  = document.getElementById('proofBar');
  const num  = document.getElementById('proofNum');
  if (!band || !bar || !num) return;
  const target = 95;
  let done = false;

  function animate() {
    if (done) return;
    done = true;
    bar.style.width = target + '%';
    const duration = 1600;
    const startTime = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      num.textContent = Math.round(progress * target) + '%';
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  const obs = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting) { animate(); obs.disconnect(); }
  }, { threshold: 0.5 });
  obs.observe(band);
})();

// ── TESTIMONIAL ROTATOR ───────────────
(function initTestimonials() {
  const slides = Array.from(document.querySelectorAll('.testimonial-slide'));
  const dots   = Array.from(document.querySelectorAll('.testimonial-dot'));
  if (!slides.length) return;
  let ti = 0;

  function show(n) {
    slides[ti].classList.remove('active');
    dots[ti]?.classList.remove('active');
    ti = ((n % slides.length) + slides.length) % slides.length;
    slides[ti].classList.add('active');
    dots[ti]?.classList.add('active');
  }

  dots.forEach((d, i) => d.addEventListener('click', () => show(i)));
  setInterval(() => show(ti + 1), 5000);
})();

